import React from "react";

export function ProductCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-3xl border border-black/5 bg-white" aria-hidden="true">
      <div className="aspect-[4/5] animate-pulse bg-olive/8" />
      <div className="space-y-3 p-4">
        <div className="h-4 w-3/4 animate-pulse rounded-full bg-olive/10" />
        <div className="h-3 w-full animate-pulse rounded-full bg-olive/8" />
        <div className="flex items-center justify-between pt-1">
          <div className="h-5 w-16 animate-pulse rounded-full bg-olive/10" />
          <div className="h-10 w-10 animate-pulse rounded-full bg-olive/10" />
        </div>
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 8, gridClass = "grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6" }) {
  return (
    <div className={gridClass} data-testid="products-skeleton">
      {Array.from({ length: count }).map((_, i) => <ProductCardSkeleton key={i} />)}
    </div>
  );
}

export function ListSkeleton({ count = 3 }) {
  return (
    <div className="space-y-4" data-testid="list-skeleton" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-olive/10 bg-white p-5">
          <div className="flex items-center justify-between">
            <div className="h-4 w-32 animate-pulse rounded-full bg-olive/10" />
            <div className="h-6 w-20 animate-pulse rounded-full bg-olive/8" />
          </div>
          <div className="mt-3 h-3 w-1/2 animate-pulse rounded-full bg-olive/8" />
          <div className="mt-2 h-3 w-1/4 animate-pulse rounded-full bg-olive/8" />
        </div>
      ))}
    </div>
  );
}
